import axios from './axiosInstance';

export const uploadImage = async ({
  data
}) => {
  try{
    const response = await axios({
      url : '/upload-image',
      method : 'POST',
      data : data
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const uploadThumbnail = async ({
  id,
  data
}) => {
  try{
    const response = await axios({
      url : `/upload-thumbnail/${id}`,
      method : 'POST',
      data : data
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}